import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
`;

export const IconPill = styled.button<{ $selected: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 44px;
	background: ${({ theme, $selected }) => ($selected ? `${theme.blue[500]}14` : theme.gray[0])};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	padding: 8px 12px;
	transition: all 0.2s ease;
	position: relative;
	width: 100%;
	text-align: left;
	outline: none;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 3px;
		height: 100%;
		background: linear-gradient(
			180deg,
			${({ theme }) => theme.blue[500]} 0%,
			${({ theme }) => theme.blue[700]} 100%
		);
		opacity: ${({ $selected }) => ($selected ? 1 : 0)};
		transition: opacity 0.2s ease;
		border-radius: 8px 0 0 8px;
	}

	&:hover,
	&:focus {
		background: ${({ theme, $selected }) => ($selected ? `${theme.blue[500]}14` : theme.gray[100])};
	}

	&:focus {
		border-color: ${({ theme }) => theme.gray[400]};
	}
`;

export const PackName = styled.div<{ $selected: boolean }>`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	white-space: nowrap;
`;

export const InlineIconsContainer = styled.div<{ $selected: boolean }>`
	display: flex;
	gap: 6px;
	flex-wrap: wrap;
	justify-content: flex-end;
	opacity: ${({ $selected }) => ($selected ? 1 : 0.4)};
`;

export const InlineIcon = styled.svg<{
	$useFill: boolean;
	$strokeWidth: number;
}>`
	width: 16px;
	height: 16px;
	stroke: ${({ theme, $useFill }) => ($useFill ? 'none' : theme.gray[1000])};
	fill: ${({ theme, $useFill }) => ($useFill ? theme.gray[1000] : 'none')};
	stroke-width: ${({ $useFill, $strokeWidth }) => ($useFill ? 0 : $strokeWidth)};
	stroke-linecap: round;
	stroke-linejoin: round;
`;
